import React from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import classNames from 'classnames';

import FieldWidgetService from '../../../Services/FieldWidgetService';
import ConfigService from "../../../Services/api/Config";
import Icon from "../../Common/Icon";
import { ReactComponent as DragIcon } from "../../../../img/dform_dragndrop_icon.svg";

import './style.scss';

class DraggableWidgetList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: 'inputs',
      widgets: {
        inputs: [],
        headers: [],
        property: [],
        unit: [],
        resident: []
      }
    };
  }

  async componentDidMount() {
    const [inputs, headers, property, unit, resident] = await Promise.all([
      FieldWidgetService.getAllDisabledWidgets('inputs'),
      FieldWidgetService.getAllDisabledWidgets('headers'),
      FieldWidgetService.getAllDisabledWidgets('property'),
      FieldWidgetService.getAllDisabledWidgets('unit'),
      FieldWidgetService.getAllDisabledWidgets('resident')
    ]);

    this.setState({
      widgets: { inputs, headers, property, unit, resident }
    });
  }


  render() {
    const { currentTab, widgets } = this.state;
    const currentWidgets = widgets[currentTab] || [];
    
    return (
      <div className='DraggableWidgetList' style={ { backgroundColor: ConfigService.getColor('tertiaryColor', 0.15)} }>
        <div className='DraggableWidgetList_Header'>
          <h2 className='DraggableWidgetList_Header_Title'>COMPONENTS</h2>
          <div className='DraggableWidgetList_Header_Tabs Tabs'>
            <div className={ classNames('Tabs_Tab', {
                    Tabs_Tab_Active: currentTab === 'inputs'
                  })
                 }
                 onClick={ () => this.setState({ currentTab: 'inputs' }) }
                 style={ { color: ConfigService.getColor('secondaryColor') } }>
              Inputs
            </div>
            <div className={ classNames('Tabs_Tab', {
                    Tabs_Tab_Active: currentTab === 'headers'
                  })
                 }
                 onClick={ () => this.setState({ currentTab: 'headers' }) }
                 style={ { color: ConfigService.getColor('secondaryColor') } }>
              Headers and others
            </div>
            <div className={ classNames('Tabs_Tab', {
                    Tabs_Tab_Active: currentTab === 'property'
                  })
                 }
                 onClick={ () => this.setState({ currentTab: 'property' }) }
                 style={ { color: ConfigService.getColor('secondaryColor') } }>
              Property Info
            </div>
            <div className={ classNames('Tabs_Tab', {
                    Tabs_Tab_Active: currentTab === 'unit'
                  })
                 }
                 onClick={ () => this.setState({ currentTab: 'unit' }) }
                 style={ { color: ConfigService.getColor('secondaryColor') } }>
              Unit Info
            </div>
            <div className={ classNames('Tabs_Tab', {
                    Tabs_Tab_Active: currentTab === 'resident'
                  })
                 }
                 onClick={ () => this.setState({ currentTab: 'resident' }) }
                 style={ { color: ConfigService.getColor('secondaryColor') } }>
              Resident Info
            </div>
          </div>
        </div>
        <div className='DraggableWidgetList_List'>
          <Droppable droppableId='DraggableWidgetList' isDropDisabled={ true }>
            { (provided, snapshot) => (
              <div ref={ provided.innerRef }>
                { currentWidgets.map((item, index) => (
                  <Draggable
                    key={ item.key }
                    draggableId={ item.key }
                    index={ index }>
                    { (provided, snapshot) => (
                      <>
                        <div
                          className='DraggableWidgetList_Widget'
                          ref={ provided.innerRef }
                          id={ item.key }
                          { ...provided.draggableProps }
                          { ...provided.dragHandleProps }>
                          <Icon width='15' height='15' color='tertiaryColor' position='Left'>
                            <DragIcon alt='dform_dragndrop_icon'/>
                          </Icon>
                          { item.widget }
                        </div>
                        { snapshot.isDragging && (
                          <div className='DraggableWidgetList_Widget'>
                            <Icon width='15' height='15' color='tertiaryColor' position='Left'>
                              <DragIcon alt='dform_dragndrop_icon'/>
                            </Icon>
                            { item.widget }
                          </div>
                        ) }
                      </>
                    ) }
                  </Draggable>
                )) }
              </div>
            ) }
          </Droppable>
        </div>
      </div>
    );
  }
}

export default DraggableWidgetList;